import React, { useLayoutEffect } from "react";
import { EntiraClinicLogo, EntiraClinicVideo, HealthPlanBrochure, NexcaliberPurpleLogo } from "../../../../../assets";
import CoreHealthImage from "../../../../../assets/CorePlanImages/CoreHealthImage.avif";
import VideoRenderer from "../../../../shared/videoRender/VideoRenderer";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import "./healthPlan.scss";

type planViewTable = {
	id: number;
	column1: string;
	column2: string;
	column3: string;
};

const HealthPlan: React.FC = (): JSX.Element => {
	const tableData: planViewTable[] = [
		{
			id: 1,
			column1: "In-Network Deductible",
			column2: "1500",
			column3: "4500"
		},
		{
			id: 2,
			column1: "Out-of-Network Deductible",
			column2: "3000",
			column3: "9000"
		},
		{
			id: 3,
			column1: "In-Network Out of Pocket Limit",
			column2: "9100",
			column3: "18200"
		}
	];

	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});

	return (
		<div className="health-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Health Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<div className="join-logos">
							<img src={NexcaliberPurpleLogo} alt="nexcaliber logo" />
							<span>And</span>
							<img src={EntiraClinicLogo} alt="Entira Logo" />
						</div>
					</div>
					<div className="plan-description">
						<ul>
							<li>
								PPO Network – percentage payable is <b>70%</b>
							</li>
							<li>
								Participants and dependents get two <b> $35</b> co-pay office visits per year outside of
								the Entira Clinic{" "}
							</li>
							<li>
								Routine Wellness covered at <b>100%</b> by the Plan
							</li>
						</ul>

						{/* <h3>Stay focused on getting well</h3> */}
						<table>
							<thead>
								<tr>
									<th className="first-type">Type</th>
									<th>Individual Plan</th>
									<th>Family Plan</th>
								</tr>
							</thead>
							<tbody>
								{tableData.map((item: planViewTable) => (
									<tr key={item.id}>
										<td>{item.column1}</td>
										<td>$ {item.column2}</td>
										<td>$ {item.column3}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
				<div className="right-section">
					<img src={CoreHealthImage} alt="" />
				</div>
			</div>
			<h3 className="sub-heading-title">Entira Featured</h3>
			<span className="sub-text">
				Our collaboration with the exceptionally talented team at the Entira Clinic ensures that you receive
				tailored and top-notch health services, all without incurring any additional costs on your part.
			</span>
			<div className="feature-grid-renderer-section">
				<div className="video-container">
					<VideoRenderer videoSource={EntiraClinicVideo} />
				</div>
				<div className="entira-featured-card-health-plan">
					<img src={EntiraClinicLogo} alt="" />
					<span>
						Unlimited office visits and free lab work via the Entira Clinic. Clinic visits are a $10 fee per
						visit
					</span>
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>
			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={HealthPlanBrochure} />
			</div>
		</div>
	);
};

export default HealthPlan;
